"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRouterDom = require("react-router-dom");
var _jsxRuntime = require("react/jsx-runtime");
/**
* Nom : RGPD.js
* Description : Ce fichier contient le texte du RGPD
* Date de création : 16 janvier 2026
*/

/* CSS et assets */
//None

/* Bibliothèques et composants */

/* Hook */
//None

/**
* RGPD : ce composant renvoi le texte du RGPD 
*
* Type : composant 
*
* Parametres : 
*  - none
*/function RGPD() {
  // Render component
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "margin-top",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
      className: "table-cell-ss table-label",
      children: "Information r\xE8glement g\xE9n\xE9ral sur la protection des donn\xE9es (RGPD)"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "paragraph",
      children: "Les informations recuillies par Asclepios Tech font l'objet d'un traitement de donn\xE9es \xE0 caract\xE8re personnel aux fins de suivi et de gestion des comptes utilisateur de l'application Boxilumix."
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "paragraph",
      children: "Ces informations seront conserv\xE9es pendant une dur\xE9e de 5 ans \xE0 compter de la date de cr\xE9ation du compte. Au del\xE0 de cette dur\xE9e, la conservations des donn\xE9es peut \xEAtre prolong\xE9e avec l'accord du d\xE9tenteur du compte pour permettre la continuit\xE9 d'utilisation de l'application Boxilumix ou feront l'objet d'un archivage dans les conditions pr\xE9vues par les dispositions relatives aux archives publiques."
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "paragraph",
      children: "Les destinataires des donn\xE9es sont les membres du personnel d'Asclepios Tech et les administrateurs identififi\xE9s dans chaque soci\xE9t\xE9 pour la gestion des acc\xE8s de leur \xE9quipe."
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "paragraph",
      children: "Conform\xE9ment au R\xE8glement G\xE9n\xE9ral Europ\xE9en sur la protection des donn\xE9es (RGPD) et \xE0 la loi Informatique et Libert\xE9s modifi\xE9e, vous disposez des droits d'acc\xE8s, de rectification, d'effacement, de limitation et d'opposition au traitement de vos donn\xE9es."
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: "paragraph",
      children: ["Vous pouvez exercez ces droits, en accompagnant votre demande de toute information permettant d'attester de votre identit\xE9, aupr\xE8s d'Asclepios Tech par courriel : ", /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
        to: "support@asclepiostech.com",
        children: "support@asclepiostech.com"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "paragraph",
      children: "Vous pouvez \xE9galement adresser toute r\xE9clamation aupr\xE8s de la CNIL."
    })]
  });
}
var _default = exports["default"] = RGPD;